import React from "react";
import { useLocation } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { openCookieSettings } from "../components/CookieBanner";
import { useLanguage } from "../i18n/LanguageContext";
import { usePageMeta } from "../hooks/usePageMeta";
import { privacy, PRIVACY_UPDATED } from "../content/privacy";

const Section = ({ section, review }) => (
  <div className="border-t border-black/15 pt-8">
    <h2 className="font-serif-aw text-2xl md:text-3xl font-normal mb-4">{section.title}</h2>
    <div className="space-y-4">
      {section.paragraphs.map((p) => (
        <p key={p.slice(0, 40)} className="font-sans-aw text-sm md:text-base text-black/80 leading-relaxed">{p}</p>
      ))}
      {review && section.confirm?.map((c) => (
        <p key={c.slice(0, 40)} data-testid="privacy-confirm-marker" className="font-sans-aw text-sm bg-yellow-100 border-l-4 border-yellow-500 px-4 py-3 text-black">{c}</p>
      ))}
    </div>
  </div>
);

const Datenschutz = () => {
  const { t, lang } = useLanguage();
  const { search } = useLocation();
  const review = new URLSearchParams(search).has("pruefen");
  usePageMeta(t.meta.privacy);

  return (
    <div data-testid="privacy-page" className="bg-white">
      <section className="pt-40 md:pt-48 pb-12 md:pb-16 px-6 md:px-12">
        <div className="max-w-[900px] mx-auto">
          <Reveal>
            <p className="font-sans-aw text-[10px] tracking-luxury uppercase text-black/50 mb-6">— {PRIVACY_UPDATED[lang]}</p>
            <h1 className="font-serif-aw text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
              {lang === "de" ? "Datenschutzerklärung" : "Privacy policy"}
            </h1>
          </Reveal>
          <button
            data-testid="privacy-cookie-settings-btn"
            onClick={openCookieSettings}
            className="mt-8 font-sans-aw text-[11px] tracking-luxury uppercase border border-black/30 hover:border-black px-5 py-3 transition-colors duration-300"
          >
            {t.footer.cookies}
          </button>
        </div>
      </section>
      <section className="px-6 md:px-12 pb-32">
        <div className="max-w-[900px] mx-auto space-y-12">
          {privacy[lang].map((section) => (
            <Section key={section.title} section={section} review={review} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
